import ExemptionsRoutes from "./ExemptionsRoutes";
import ExemptionsStore from "./ExemptionsStore";
import ExemptionLinks from "./ExemptionLinks";

export default {
  install(Vue, options) {
    if (options.router) {
      options.router.addRoute(...ExemptionsRoutes);
    }
    if (options.store) {
      options.store.registerModule("Exemption", ExemptionsStore);
    }
    options.store.commit("Dashboard/SET_LINKS", ExemptionLinks);
  },
};
